var _a;
import { MaterialType } from "../types";
export var materialTables = (_a = {},
    _a[MaterialType.MildSteel] = {
        16: { wellScreenWeight: 52.36, wellCasingWeight: 62.58 },
        18: { wellScreenWeight: 59.03, wellCasingWeight: 70.59 },
        20: { wellScreenWeight: 65.71, wellCasingWeight: 78.6 },
    },
    _a[MaterialType.CopperBearingSteel] = {
        16: { wellScreenWeight: 54.44, wellCasingWeight: 65.08 },
        18: { wellScreenWeight: 61.12, wellCasingWeight: 73.09 },
        20: { wellScreenWeight: 67.79, wellCasingWeight: 81.1 },
    },
    _a[MaterialType.HSLA] = {
        16: { wellScreenWeight: 54.44, wellCasingWeight: 65.08 },
        18: { wellScreenWeight: 61.12, wellCasingWeight: 73.09 },
        20: { wellScreenWeight: 67.79, wellCasingWeight: 81.1 },
    },
    _a[MaterialType.StainlessSteel304] = {
        16: { wellScreenWeight: 55.72, wellCasingWeight: 66.6 },
        18: { wellScreenWeight: 62.55, wellCasingWeight: 74.8 },
        20: { wellScreenWeight: 69.38, wellCasingWeight: 83.0 },
    },
    _a[MaterialType.StainlessSteel316] = {
        16: { wellScreenWeight: 55.72, wellCasingWeight: 66.6 },
        18: { wellScreenWeight: 62.55, wellCasingWeight: 74.8 },
        20: { wellScreenWeight: 69.38, wellCasingWeight: 83.0 },
    },
    _a);
